import { ColumnType, Operator } from '../generated';
//   | typeof Operator.IS_BEFORE
//   | typeof Operator.IS_AFTER>;
export const StringFilterValue = [
    Operator.Equals,
    Operator.NotEquals,
    Operator.Contains,
    Operator.NotContains,
    Operator.StartsWith,
    Operator.Empty,
    Operator.NotEmpty,
    Operator.Duplicity,
];
export const NumberFilterValue = [
    Operator.Equals,
    Operator.NotEquals,
    Operator.LessThan,
    Operator.LessThanOrEqual,
    Operator.GreaterThan,
    Operator.GreaterThanOrEqual,
    Operator.Duplicity,
];
export const BooleanFilterValue = [Operator.Equals, Operator.NotEquals];
export const EnumFilterValue = [Operator.Equals, Operator.NotEquals, Operator.Empty, Operator.NotEmpty];
export const DateFilterValue = [
    Operator.Equals,
    Operator.NotEquals,
    Operator.LessThan,
    Operator.LessThanOrEqual,
    Operator.GreaterThan,
    Operator.GreaterThanOrEqual,
];
export const columnTypeOperators = {
    [ColumnType.String]: StringFilterValue,
    [ColumnType.Number]: NumberFilterValue,
    [ColumnType.Enum]: EnumFilterValue,
    [ColumnType.Timestamp]: DateFilterValue,
    [ColumnType.Boolean]: BooleanFilterValue,
};
export const arrayOperators = [Operator.Contains, Operator.Empty, Operator.NotEmpty];
export const operatorsWithoutValue = [Operator.Duplicity, Operator.Empty, Operator.NotEmpty];
export const operatorsWithAutocomplete = [
    Operator.Equals,
    Operator.NotEquals,
    Operator.LessThan,
    Operator.LessThanOrEqual,
    Operator.GreaterThan,
    Operator.GreaterThanOrEqual,
];
export const operatorsWithPartialInput = [
    Operator.Contains,
    Operator.NotContains,
    Operator.StartsWith,
    //  'ENDS_WITH', // backend supports it, may not be in generated Operator enum
];
export const operatorDescriptor = {
    [Operator.Contains]: {
        id: 'filter.operator.contains',
        defaultMessage: 'contains',
    },
    [Operator.Empty]: { id: 'filter.operator.empty', defaultMessage: 'empty' },
    [Operator.NotEmpty]: { id: 'filter.operator.notEmpty', defaultMessage: 'not empty' },
    [Operator.Equals]: { id: 'filter.operator.equals', defaultMessage: 'equals' },
    [Operator.NotEquals]: {
        id: 'filter.operator.notEquals',
        defaultMessage: 'not equals',
    },
    [Operator.GreaterThan]: {
        id: 'filter.operator.graterThan',
        defaultMessage: 'grater than',
    },
    [Operator.LessThan]: {
        id: 'filter.operator.lessThan',
        defaultMessage: 'less than',
    },
    [Operator.LessThanOrEqual]: {
        id: 'filter.operator.lessThanOrEqual',
        defaultMessage: 'less than or equal',
    },
    [Operator.NotContains]: {
        id: 'filter.operator.notContains',
        defaultMessage: 'not contains',
    },
    [Operator.StartsWith]: {
        id: 'filter.operator.startWith',
        defaultMessage: 'start with',
    },
    [Operator.GreaterThanOrEqual]: {
        id: 'filter.operator.greaterThanOrEqual',
        defaultMessage: 'greater than or equal',
    },
};
//# sourceMappingURL=typeOperators.js.map